import type { PaymentStatus } from '~entities/payment';

import type { MultiSelectOption } from '~shared/ui/multi-select-filter';

export const PAYMENT_STATUS_OPTIONS: MultiSelectOption[] = [
  { value: 'IN_PROGRESS', label: 'In progress' },
  { value: 'SETTLED', label: 'Settled' },
] satisfies { value: PaymentStatus; label: string }[];
